module.exports = __webpack_public_path__ + "static/img/smallCode.d93ed6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/smallCode.jpg
// module id = Pzqe
// module chunks = 1